module.exports = __webpack_public_path__ + "img/character.cf674f14.svg";